import React, { FC } from 'react';
import styled        from 'styled-components';
import { Button }    from '@components/Button/Button';
import { Grid }      from '@material-ui/core';

const ReindeerTitle = styled.p`
  font-weight : 500;
  padding     : 20px 5px;
`;

interface IProps {
  reindeerBtnLabel    : string;
  isLoadingReindeer   : boolean;
  onReindeerAuthClick : (cuid: string) => Promise<void>;
}

export const ReindeerBlock: FC<IProps> = ({
  reindeerBtnLabel,
  isLoadingReindeer,
  onReindeerAuthClick,
}) => (
  <>
    <ReindeerTitle>Reindeer Authorization</ReindeerTitle>

    <Grid item xs={12} sm={4}>
      <Button
        onClick   = {onReindeerAuthClick}
        label     = {reindeerBtnLabel}
        disabled  = {isLoadingReindeer}
        isLoading = {isLoadingReindeer}
        margin    = "0"
        fullWidth
      />
    </Grid>
  </>
);
